import { isValid, getYear } from 'date-fns';
export default function validateDate(value) {
  if (!value) {
    return undefined;
  }
  const date = new Date(value);
  if (!isValid(date)) {
    return undefined;
  }

  /*
  ISO8601 format
  While typing, some strings come as "incomplete", such as 0202-05-01
  Although date-fns returns this value as valid, it goes against ISO8601 format
  where year, for example, needs 4 digits
  */
  if (getYear(date) < 1000) {
    return undefined;
  }
  return date;
}